var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'common/location', 'app-common/component/loader', 'app-common/component/notification', 'lib/fileuploader'], function($, _, location, loader, NotificationSupport, qq) {
  var allowedDisplayableExts, allowedInternalExts, allowedOtherExts, getExtension;
  allowedDisplayableExts = ['jpg', 'jpeg', 'pdf', 'heic', 'png', 'tiff', 'tif', 'doc', 'docx'];
  allowedOtherExts = ['csv', 'xls', 'xlsx', 'iif'];
  allowedInternalExts = ['csv', 'xls', 'xlsx', 'xlsm', 'iif', 'jpg', 'jpeg', 'pdf', 'heic', 'png', 'tiff', 'tif', 'doc', 'docx'];
  getExtension = function(filename) {
    if (filename.indexOf('.') !== -1) {
      return filename.replace(/.*[.]/, '').toLowerCase();
    } else {
      return '';
    }
  };
  return {
    isDisplayableFile: function(filename) {
      return _.contains(allowedDisplayableExts, getExtension(filename));
    },
    isAllowedFile: function(filename) {
      return _.contains(_.union(allowedDisplayableExts, allowedOtherExts), getExtension(filename));
    },
    initUploader: function(settings) {
      var SimpleNotification, notification, uploader;
      SimpleNotification = (function(_super) {

        __extends(SimpleNotification, _super);

        function SimpleNotification() {
          SimpleNotification.__super__.constructor.apply(this, arguments);
        }

        SimpleNotification.prototype.notificationSelector = function() {
          return '.widget .notification-area';
        };

        return SimpleNotification;

      })(NotificationSupport);
      notification = new SimpleNotification;
      uploader = {
        multiple: settings.multiple || false,
        element: settings.container,
        action: "" + location.apiRoot + "/api/v1/file.json",
        maxConnections: 1,
        params: settings.params,
        allowedExtensions: (settings.extensions != null) ? settings.extensions : _.union(allowedDisplayableExts, allowedOtherExts, allowedInternalExts),
        onSubmit: function(id, fileName) {
          if (_.isFunction(settings.onSubmit)) {
            return settings.onSubmit(id, fileName);
          }
        },
        onCancel: function() {
          if (_.isFunction(settings.onCancel)) {
            return settings.onCancel;
          }
        },
        onProgress: function(id, fileName, loaded, total) {
          if (_.isFunction(settings.onProgress)) {
            return settings.onProgress(id, fileName, loaded, total);
          }
        },
        onComplete: function(id, fileName, responseJSON) {
          if (responseJSON.result === '') {
            return;
          }
          if (_.isFunction(settings.onComplete)) {
            return settings.onComplete(id, fileName, responseJSON);
          }
        },
        showMessage: function(message) {
          notification.showNotification({
            type: 'error',
            text: message
          });
          if (_.isFunction(settings.onError)) {
            return settings.onError();
          }
        }
      };
      if (settings.template != null) {
        uploader.template = settings.template;
      }
      return new qq.FileUploader(uploader);
    }
  };
});
